export const mockLeaveRequests = [
  {
    uuid: "leave-001",
    organization_uuid: "org-001",
    employee_uuid: "emp-001",
    leave_balance_uuid: "bal-001",
    start_date: "2026-06-01",
    end_date: "2026-06-03",
    total_days: 2,
    reason: "Casual Leave",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-002",
    organization_uuid: "org-001",
    employee_uuid: "emp-002",
    leave_balance_uuid: "bal-002",
    start_date: "2026-06-02",
    end_date: "2026-06-04",
    total_days: 2,
    reason: "Medical Leave",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-003",
    organization_uuid: "org-001",
    employee_uuid: "emp-003",
    leave_balance_uuid: "bal-003",
    start_date: "2026-06-03",
    end_date: "2026-06-05",
    total_days: 2,
    reason: "Annual Vacation",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-004",
    organization_uuid: "org-001",
    employee_uuid: "emp-004",
    leave_balance_uuid: "bal-004",
    start_date: "2026-06-04",
    end_date: "2026-06-06",
    total_days: 2,
    reason: "Earned Leave",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-005",
    organization_uuid: "org-001",
    employee_uuid: "emp-005",
    leave_balance_uuid: "bal-005",
    start_date: "2026-06-05",
    end_date: "2026-06-07",
    total_days: 2,
    reason: "Personal Emergency",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-006",
    organization_uuid: "org-001",
    employee_uuid: "emp-006",
    leave_balance_uuid: "bal-006",
    start_date: "2026-06-06",
    end_date: "2026-06-08",
    total_days: 2,
    reason: "Casual Leave",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-007",
    organization_uuid: "org-001",
    employee_uuid: "emp-007",
    leave_balance_uuid: "bal-007",
    start_date: "2026-06-07",
    end_date: "2026-06-09",
    total_days: 2,
    reason: "Medical Leave",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-008",
    organization_uuid: "org-001",
    employee_uuid: "emp-008",
    leave_balance_uuid: "bal-008",
    start_date: "2026-06-08",
    end_date: "2026-06-10",
    total_days: 2,
    reason: "Annual Vacation",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-009",
    organization_uuid: "org-001",
    employee_uuid: "emp-009",
    leave_balance_uuid: "bal-009",
    start_date: "2026-06-09",
    end_date: "2026-06-11",
    total_days: 2,
    reason: "Earned Leave",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-010",
    organization_uuid: "org-001",
    employee_uuid: "emp-010",
    leave_balance_uuid: "bal-010",
    start_date: "2026-06-10",
    end_date: "2026-06-12",
    total_days: 2,
    reason: "Personal Emergency",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-011",
    organization_uuid: "org-001",
    employee_uuid: "emp-011",
    leave_balance_uuid: "bal-001",
    start_date: "2026-06-11",
    end_date: "2026-06-13",
    total_days: 2,
    reason: "Casual Leave",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-012",
    organization_uuid: "org-001",
    employee_uuid: "emp-012",
    leave_balance_uuid: "bal-002",
    start_date: "2026-06-12",
    end_date: "2026-06-14",
    total_days: 2,
    reason: "Medical Leave",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-013",
    organization_uuid: "org-001",
    employee_uuid: "emp-013",
    leave_balance_uuid: "bal-003",
    start_date: "2026-06-13",
    end_date: "2026-06-15",
    total_days: 2,
    reason: "Annual Vacation",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-014",
    organization_uuid: "org-001",
    employee_uuid: "emp-014",
    leave_balance_uuid: "bal-004",
    start_date: "2026-06-14",
    end_date: "2026-06-16",
    total_days: 2,
    reason: "Earned Leave",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-015",
    organization_uuid: "org-001",
    employee_uuid: "emp-015",
    leave_balance_uuid: "bal-005",
    start_date: "2026-06-15",
    end_date: "2026-06-17",
    total_days: 2,
    reason: "Personal Emergency",
    status: "Approved",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request approved.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-016",
    organization_uuid: "org-001",
    employee_uuid: "emp-016",
    leave_balance_uuid: "bal-006",
    start_date: "2026-06-16",
    end_date: "2026-06-18",
    total_days: 2,
    reason: "Casual Leave",
    status: "Pending",
    decided_by_employee_uuid: null,
    decided_at: null,
    remarks: "Leave request pending.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-017",
    organization_uuid: "org-001",
    employee_uuid: "emp-017",
    leave_balance_uuid: "bal-007",
    start_date: "2026-06-17",
    end_date: "2026-06-19",
    total_days: 2,
    reason: "Medical Leave",
    status: "Pending",
    decided_by_employee_uuid: null,
    decided_at: null,
    remarks: "Leave request pending.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-018",
    organization_uuid: "org-001",
    employee_uuid: "emp-018",
    leave_balance_uuid: "bal-008",
    start_date: "2026-06-18",
    end_date: "2026-06-20",
    total_days: 2,
    reason: "Annual Vacation",
    status: "Pending",
    decided_by_employee_uuid: null,
    decided_at: null,
    remarks: "Leave request pending.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-019",
    organization_uuid: "org-001",
    employee_uuid: "emp-019",
    leave_balance_uuid: "bal-009",
    start_date: "2026-06-19",
    end_date: "2026-06-21",
    total_days: 2,
    reason: "Earned Leave",
    status: "Pending",
    decided_by_employee_uuid: null,
    decided_at: null,
    remarks: "Leave request pending.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-020",
    organization_uuid: "org-001",
    employee_uuid: "emp-020",
    leave_balance_uuid: "bal-010",
    start_date: "2026-06-20",
    end_date: "2026-06-22",
    total_days: 2,
    reason: "Personal Emergency",
    status: "Pending",
    decided_by_employee_uuid: null,
    decided_at: null,
    remarks: "Leave request pending.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-021",
    organization_uuid: "org-001",
    employee_uuid: "emp-001",
    leave_balance_uuid: "bal-001",
    start_date: "2026-06-01",
    end_date: "2026-06-03",
    total_days: 2,
    reason: "Casual Leave",
    status: "Pending",
    decided_by_employee_uuid: null,
    decided_at: null,
    remarks: "Leave request pending.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-022",
    organization_uuid: "org-001",
    employee_uuid: "emp-002",
    leave_balance_uuid: "bal-002",
    start_date: "2026-06-02",
    end_date: "2026-06-04",
    total_days: 2,
    reason: "Medical Leave",
    status: "Pending",
    decided_by_employee_uuid: null,
    decided_at: null,
    remarks: "Leave request pending.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-023",
    organization_uuid: "org-001",
    employee_uuid: "emp-003",
    leave_balance_uuid: "bal-003",
    start_date: "2026-06-03",
    end_date: "2026-06-05",
    total_days: 2,
    reason: "Annual Vacation",
    status: "Pending",
    decided_by_employee_uuid: null,
    decided_at: null,
    remarks: "Leave request pending.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-024",
    organization_uuid: "org-001",
    employee_uuid: "emp-004",
    leave_balance_uuid: "bal-004",
    start_date: "2026-06-04",
    end_date: "2026-06-06",
    total_days: 2,
    reason: "Earned Leave",
    status: "Rejected",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request rejected.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-025",
    organization_uuid: "org-001",
    employee_uuid: "emp-005",
    leave_balance_uuid: "bal-005",
    start_date: "2026-06-05",
    end_date: "2026-06-07",
    total_days: 2,
    reason: "Personal Emergency",
    status: "Rejected",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request rejected.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-026",
    organization_uuid: "org-001",
    employee_uuid: "emp-006",
    leave_balance_uuid: "bal-006",
    start_date: "2026-06-06",
    end_date: "2026-06-08",
    total_days: 2,
    reason: "Casual Leave",
    status: "Rejected",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request rejected.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-027",
    organization_uuid: "org-001",
    employee_uuid: "emp-007",
    leave_balance_uuid: "bal-007",
    start_date: "2026-06-07",
    end_date: "2026-06-09",
    total_days: 2,
    reason: "Medical Leave",
    status: "Rejected",
    decided_by_employee_uuid: "emp-001",
    decided_at: "2026-05-28T11:00:00.000Z",
    remarks: "Leave request rejected.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-028",
    organization_uuid: "org-001",
    employee_uuid: "emp-008",
    leave_balance_uuid: "bal-008",
    start_date: "2026-06-08",
    end_date: "2026-06-10",
    total_days: 2,
    reason: "Annual Vacation",
    status: "Cancelled",
    decided_by_employee_uuid: null,
    decided_at: null,
    remarks: "Leave request cancelled.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-029",
    organization_uuid: "org-001",
    employee_uuid: "emp-009",
    leave_balance_uuid: "bal-009",
    start_date: "2026-06-09",
    end_date: "2026-06-11",
    total_days: 2,
    reason: "Earned Leave",
    status: "Cancelled",
    decided_by_employee_uuid: null,
    decided_at: null,
    remarks: "Leave request cancelled.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  },
  {
    uuid: "leave-030",
    organization_uuid: "org-001",
    employee_uuid: "emp-010",
    leave_balance_uuid: "bal-010",
    start_date: "2026-06-10",
    end_date: "2026-06-12",
    total_days: 2,
    reason: "Personal Emergency",
    status: "Cancelled",
    decided_by_employee_uuid: null,
    decided_at: null,
    remarks: "Leave request cancelled.",
    created_at: "2026-05-25T09:00:00.000Z",
    updated_at: "2026-05-28T11:00:00.000Z"
  }
];